<aside #railRoot class="doc-preview-rail" [class.collapsed]="$collapsed()" [class.pinned]="$pinned()" [class.has-pin]="$showPin()" [class.tabless]="$tabless()" [class.has-title]="!!$title()">

  <div class="head" [class.has-pin]="$showPin()">
    @if ($title(); as title) {
      <h2 class="rail-title">{{ title }}</h2>
    }
    @if ($showPin()) {
      <wb-button-icon class="rail-head-btn" [iconLeft]="$pinIcon()" displayStyle="Tertiary" size="Small" [tooltip]="$pinTooltip()" (onClick)="togglePin()" />
    }
    <wb-button-icon class="rail-head-btn rail-toggle-btn" iconLeft="fa-regular fa-table-columns" displayStyle="Tertiary" size="Small" [tooltip]="$toggleTooltip()" [disabled]="$busy()" (onClick)="toggleRail()" />
  </div>

  @if (!$collapsed()) {
    <div class="body">
      @if ($tabless()) {
        <ng-container *ngTemplateOutlet="$railContentTemplate() ?? null" />
      } @else {
        <wb-tab-shell [tabs]="$stripTabs()" [selectedTab]="$activeTab()" (selectedTabChange)="$activeTab.set($event)" (focusin)="focusPanelControl($event)">
          <ng-template #tabContent let-tab>
            <ng-container *ngTemplateOutlet="$tabContentTemplate() ?? null; context: { $implicit: tab }" />
          </ng-template>
        </wb-tab-shell>
      }
    </div>
  } @else if (!$tabless()) {
    <div class="collapsed-tabs">
      @for (tab of $collapsedTabs(); track tab.value) {
        <button type="button" class="collapsed-tab" (click)="openTab(tab.value)">
          <span>{{ tab.label }}</span>
        </button>
      }
    </div>
  }

</aside>
